import {
  type Breakpoint,
  breakpointsOrder,
  useBreakpoint,
} from './useBreakpoint'

export const useBreakpointMatch = (breakpoint: Breakpoint): boolean => {
  const currentBreakpoint = useBreakpoint()

  if (!currentBreakpoint) {
    return false
  }

  const index = breakpointsOrder.indexOf(breakpoint)
  const matchingBreakpoints = breakpointsOrder.slice(0, index)

  return matchingBreakpoints.includes(currentBreakpoint)
}
